import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-maintenance-banner',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './maintenance-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./maintenance-banner.component.scss'],
})
export class MaintenanceBannerComponent {
  @Input() message: string | null = null;
  @Input() compact = false;
}
